import React from 'react';
import ReactDOM from 'react-dom/client';
import { ApolloProvider } from '@apollo/client';
import App from './App';
import useApollo from './hooks/useApollo';

const Wrapper = () => {
  // Setting up graphQL client.
  const client = useApollo();

  return (
    <ApolloProvider client={client}>
      <App />
    </ApolloProvider>
  );
};

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(<Wrapper />);
